const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

document.addEventListener('DOMContentLoaded',function() {

    const btn = document.querySelectorAll('[data-popup]');
   
    const init = function() {

		const overlay = document.getElementById('overlay');				

        const action = function(e) {
            const target = e.currentTarget.dataset.popup;
            
            disableBodyScroll(overlay);
            
            document.getElementById(target).classList.remove('is-hidden');
            
            overlay.classList.remove('is-hidden');
            window.checkWindowHeight();
            
            setTimeout(function() {
                overlay.classList.add('is-visible');
                document.addEventListener('click', window.clickOutside);
            }, 100);
            
            e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
        };
	
        for (let i = 0; i < btn.length; i++) {
            btn[i].addEventListener('click', action);
        }
	};

    btn.length > 0 ? init() : false;

}, false);